import { newsletterSchema } from '~/utils/crystallize/newsletter'

export function useNewsletterCmsData() {
  const options = useCatalogueQueryOptions({ path: '/nyhetsbrev', schema: newsletterSchema })

  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}
